<div class="layout-footer">
    <div class="footer-top">
        <div class="footer-logo-container">
            <img [src]="'assets/layout/images/icon-white.png'" alt="logo" />
        </div>
        <a class="text-footer login-link" href="/login">Iniciar Sesión</a>
    </div>

    <p-divider></p-divider>

    <div class="footer-middle">
        <div class="social-links">
            <button pButton pRipple type="button" icon="pi pi-instagram" class="p-button-rounded p-button-text p-button-plain"></button>
            <button pButton pRipple type="button" icon="pi pi-whatsapp" class="p-button-rounded p-button-text p-button-plain"></button>
            <button pButton pRipple type="button" icon="pi pi-facebook" class="p-button-rounded p-button-text p-button-plain"></button>
            <button pButton pRipple type="button" icon="pi pi-twitter" class="p-button-rounded p-button-text p-button-plain"></button>
        </div>
        <nav class="footer-nav">
            <a class="text-footer" href="">Inicio</a>
            <a class="text-footer" href="">Sobre Nosotros</a>
            <a class="text-footer" href="">Cómo Funciona</a>
            <a class="text-footer" href="">Planes</a>
            <a class="text-footer" href="">Índices</a>
            <a class="text-footer" href="">Contacto</a>
        </nav>
    </div>

    <div class="footer-bottom">
        <div class="footer-copyright">
            <span>Copyright 2024. Tadic List</span>
        </div>
        <div class="footer-links">
            <a href="">Política de Privacidad</a>
            <a href="">Términos de Uso</a>
            <a href="">Refiere a un Amigo</a>
        </div>
    </div>
</div>
